// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1gxcQ","info":"Note_info__FDrZa","note":"Note_note__1j0Be","actions":"Note_actions__19a3O"};